import React, { useState, useEffect } from 'react';
import { Button, Card, Spinner, Container, Row, Col } from 'react-bootstrap';
import { Chip } from '@mui/material';
import * as Icon from 'react-bootstrap-icons';
import UserMark from '../UserMark';
import PlanConfirmDialog from './PlanConfirmDialog';
import ApiFetch from '../ApiFetch';

const OfficialPlanCards = ({ isRRated = false, dialog, loginInfo }) => {
    const [checkoutProcess, setCheckoutProcess] = useState(false);
    const [officialPlan, setOfficialPlan] = useState([]);

    // プラン情報取得
    async function getOfficialPlan() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/coin/official").then((r) => r.json());
    }

    // Stripe決済チェックアウト
    async function checkout(plan) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/checkout/subscribe/" + plan).then((r) => r.json());
    }

    useEffect(() => {
        getOfficialPlan().then(r => {
            if (r.result) {
                setOfficialPlan(r.data);
            } else {
                setOfficialPlan([]);
            }
        });
    }, []);

    function checkoutProcessHandler(plan) {
        setCheckoutProcess(true);
        try {
            if (isRRated) {
                // R指定の場合はコイン決済のみ - Legal.jsページに誘導
                window.location.href = "/legal";
                return;
            }
            
            // Stripe決済
            checkout(plan).then(r => {
                if (r.result) {
                    window.location.href = r.data.url;
                } else {
                    dialog("エラー", r.errors);
                    setCheckoutProcess(false);
                }
            });
        } catch (error) {
            setCheckoutProcess(false);
        }
    }

    const plans = [
        {
            id: "certification",
            name: "Standard スタンダード",
            plan: "certification",
            item_id: "8db00aac-09a0-11ef-9428-0242ac130002",
            dollarPrice: "$10",
            yenPrice: "1,400円",
            dollarPlan: "standard_dollar",
            yenPlan: "standard_yen",
            color: "#6366f1",
            features: [
                "広告非表示",
                "黄色認証マークの表示(要SMS認証)",
                "画像生成回数を拡張",
                "生成画像のロゴ削除",
                "優先して生成"
            ]
        },
        {
            id: "unlimited",
            name: "Premium プレミアム",
            plan: "unlimited",
            item_id: "9042b934-09a0-11ef-9428-0242ac130002",
            dollarPrice: "$30",
            yenPrice: "4,000円",
            dollarPlan: "premium_dollar",
            yenPlan: "premium_yen",
            color: "#8b5cf6",
            isRecommended: true,
            features: [
                "広告非表示",
                "黄色認証マークの表示(要SMS認証)",
                "さらに多くの画像生成が可能",
                "生成画像のロゴ削除",
                "高品質モデルの利用",
                "優先して生成"
            ]
        },
        {
            id: "plus",
            name: "Premium + プレミアムプラス",
            plan: "plus",
            item_id: "9042b951-09a0-11ef-9428-0242ac130002",
            dollarPrice: "$140",
            yenPrice: "20,000円",
            dollarPlan: "plus_dollar",
            yenPlan: "plus_yen",
            color: "#a855f7",
            features: [
                "広告非表示",
                "黄色認証マークの表示(要SMS認証)",
                "大幅に拡張された画像生成機能",
                "生成画像のロゴ削除",
                "プレミアム高品質モデルの利用",
                "優先して生成"
            ]
        }
    ];

    return (
        <Container className="mt-3 mb-3">
            <div style={{ fontFamily: "Meiryo UI", textAlign: "center", marginBottom: "20px" }}>
                {isRRated ? (
                    <div style={{ color: "#e53e3e", fontWeight: "bold", fontSize: "16px", marginBottom: "10px" }}>
                        ※ R指定コンテンツの閲覧にはコイン決済でのプラン加入が必要です
                    </div>
                ) : null}
                <div style={{ fontWeight: "bold", fontSize: "18px" }}>
                    アワートAI公式プラン（スタンダード以上）に加入すると、このコンテンツを閲覧できます
                </div>
            </div>
            <Row className="justify-content-center">
                {plans.map((planData, i) => (
                    <Col lg={4} md={6} className="mb-4" key={i}>
                        <Card 
                            className="h-100 border-0 position-relative" 
                            style={{
                                borderRadius: "12px",
                                boxShadow: planData.isRecommended 
                                    ? "0 6px 25px rgba(255, 193, 7, 0.12)" 
                                    : "0 4px 20px rgba(0,0,0,0.08)",
                                transition: "all 0.3s ease",
                                background: "#ffffff",
                                border: planData.isRecommended 
                                    ? "2px solid #ffc107" 
                                    : "1px solid #e2e8f0",
                                transform: planData.isRecommended ? "scale(1.02)" : "scale(1)"
                            }}
                        >
                            {planData.isRecommended && (
                                <div className="position-absolute top-0 start-50 translate-middle">
                                    <Chip 
                                        label="オススメ" 
                                        style={{
                                            background: "#ffc107",
                                            color: "#2d3748",
                                            fontWeight: "600",
                                            fontSize: "12px"
                                        }}
                                    />
                                </div>
                            )}
                            <Card.Body className="d-flex flex-column" style={{ paddingTop: planData.isRecommended ? "30px" : "20px" }}>
                                <div className="text-center mb-3">
                                    <h4 className="fw-bold" style={{ color: "#2d3748", fontSize: "18px" }}>
                                        {planData.name}
                                    </h4>
                                    <UserMark plan={planData.plan} dialog={() => false} />
                                </div>
                                <div 
                                    className="text-center mb-4 p-3" 
                                    style={{
                                        background: planData.color,
                                        borderRadius: "10px",
                                        color: "white"
                                    }}
                                >
                                    <div className="h3 fw-bold">{planData.dollarPrice}</div>
                                    <small style={{ opacity: "0.9" }}>1か月ごと</small>
                                    <div className="h3 fw-bold mt-2">{planData.yenPrice}</div>
                                    <small style={{ opacity: "0.9" }}>1か月ごと</small>
                                </div>
                                <div className="mb-3">
                                    {isRRated ? (
                                        ""
                                    ) : (
                                        <>
                                            <Button 
                                                className="w-100 mb-2 border-0" 
                                                    style={{
                                                    background: "transparent",
                                                    border: `1px solid ${planData.color}`,
                                                    borderRadius: "8px",
                                                    padding: "10px 0",
                                                    fontWeight: "500",
                                                    color: planData.color,
                                                    transition: "all 0.3s ease"
                                                }}
                                                onClick={() => checkoutProcessHandler(planData.dollarPlan)}
                                                disabled={checkoutProcess}
                                            >
                                                {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する ({planData.dollarPrice})
                                            </Button>
                                            <Button 
                                                className="w-100 border-0" 
                                                style={{
                                                    background: planData.color,
                                                    borderRadius: "8px",
                                                    padding: "10px 0",
                                                    fontWeight: "500",
                                                    color: "white",
                                                    transition: "all 0.3s ease"
                                                }}
                                                onClick={() => checkoutProcessHandler(planData.yenPlan)}
                                                disabled={checkoutProcess}
                                            >
                                                {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する ({planData.yenPrice})
                                            </Button>
                                        </>
                                    )}
                                </div>
                                <PlanConfirmDialog data={{
                                    "item_id": planData.item_id,
                                    "subscription_id": loginInfo.plan === planData.id ? officialPlan.subscription_id : "",
                                    "name": planData.name,
                                    "user_name": "アワートAI公式",
                                    "amount": parseInt(planData.yenPrice.replace(/[^0-9]/g, "")),
                                    "status": loginInfo.plan === planData.id ? "ACTIVE" : "",
                                    "official": true
                                }} />
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default OfficialPlanCards;
